import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  listActivityDataYearly() {
    return axios.get('/v1/companyemissions/activity-data-years/')
  },
  reportingYearEndActualEmissionsData(companyId: number | string) {
    return axios.get(
      `/v1/companyemissions/veridis-reporting-year-graph-actual-emissions/${companyId}/`,
    )
  },
  baseReportingYearEmissions(companyId: number | string) {
    return axios.get(`/v1/companyemissions/veridis-base-year-reporting-year-emissions/${companyId}/`)
  },
  reportingYearEmissions(companyId: number | string) {
    return axios.get(`/v1/companyemissions/reporting-year-emissions/${companyId}/`)
  },
  previousReportingYearEmissions(companyId: number | string) {
    return axios.get(`/v1/companyemissions/veridis-previous-year-reporting-year-emissions/${companyId}/`)
  },
  updateEmissionDataLogs(bulkDataAnswers: []) {
    return axios.put('/v1/companyemissions/data/logs/bulk/update/data-add/', bulkDataAnswers)
  },
  getCategories() {
    return axios.get(`/v1/emissiontracker/categories/`)
  },
  emissionHistoricalYears(companyId: number | string) {
    return axios.get(`/v1/companyemissions/veridis-emission-years-historical-years/${companyId}/`)
  },
})
